module.exports = "/_next/static/resources/pack-4b85587a4814d5609bd5ca5f65168060.webp";